
import 'antd/dist/antd.css';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import Statistic from 'antd/lib/statistic'
import Row from 'antd/lib/row';
import Card from 'antd/lib/card';
import Col from 'antd/lib/col'
const FooeterStats = () => {
    return (
        <div className="site-statistic-demo-card">
    <Row gutter={16}>
      <Col span={12}>
        <Card>
          <Statistic
            title="Active Users"
            value={45.28}
            precision={2}
            valueStyle={{ color: '#3f8600' }}
            prefix={<ArrowUpOutlined />}
            suffix="%"
          />
        </Card>
      </Col>
      <Col span={12}>
        <Card>
          <Statistic
            title="InActive Users"
            value={11.30}
            precision={2}
            valueStyle={{ color: '#cf1322' }}
            prefix={<ArrowDownOutlined />}
            suffix="%"
          />
        </Card>
      </Col>
    </Row>
  </div>
    )
}

export default FooeterStats